import { Component, EventEmitter, Input, Output } from '@angular/core'
import { Observable } from 'rxjs'
import { MatIcon } from '@angular/material/icon'
import { NgxPaginationModule } from 'ngx-pagination'
import { AsyncPipe, NgFor, NgIf } from '@angular/common'
import { FileAttach } from '../../models/files.interface'

@Component({
    selector: 'app-file-grid',
    standalone: true,
    imports: [MatIcon, NgxPaginationModule, NgIf, AsyncPipe, NgFor],
    templateUrl: './file-grid.component.html',
    styleUrl: './file-grid.component.css',
})
export class FileGridComponent {
    @Input() asyncFiles!: Observable<FileAttach[]>

    @Output() onSelectFile = new EventEmitter<{ bucket: string }>()

    constructor() {}

    select(file: FileAttach) {
        this.onSelectFile.emit({ bucket: file.bucketId })
    }

    ngOnInit(): void {}
}
